/**
 * @generated SignedSource<<5d54e36aadacf8d0dca5354715d21f68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BranchPickerSharedRepositoryBranchRefs$data = {
  readonly defaultBranchRef: {
    readonly " $fragmentSpreads": FragmentRefs<"BranchPickerSharedRef">;
  } | null | undefined;
  readonly id: string;
  readonly refs: {
    readonly " $fragmentSpreads": FragmentRefs<"BranchPickerSharedRepositoryBranches">;
  } | null | undefined;
  readonly " $fragmentType": "BranchPickerSharedRepositoryBranchRefs";
};
export type BranchPickerSharedRepositoryBranchRefs$key = {
  readonly " $data"?: BranchPickerSharedRepositoryBranchRefs$data;
  readonly " $fragmentSpreads": FragmentRefs<"BranchPickerSharedRepositoryBranchRefs">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "BranchPickerSharedRepositoryBranchRefs"
};

(node as any).hash = "ef6f74da691fb6afc80c085d6a6d3991";

export default node;
